import api from './api';

export const authService = {
  // Retorna o body do /auth/login. Se vier requiresRoleSelection=true,
  // o componente Login exibe o seletor e refaz o POST com loginAs.
  async login(email, password, loginAs) {
    const payload = { email, password };
    if (loginAs) payload.loginAs = loginAs;
    const response = await api.post('/auth/login', payload);

    if (response.data?.requiresRoleSelection) {
      return response.data;
    }

    const { accessToken, refreshToken, user } = response.data;
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('refreshToken', refreshToken);
    localStorage.setItem('user', JSON.stringify(user));
    return { user };
  },

  async logout() {
    try {
      await api.post('/auth/logout');
    } catch (error) {
      console.error('Erro ao fazer logout:', error);
    } finally {
      localStorage.clear();
    }
  },

  getCurrentUser() {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },

  isAuthenticated() {
    return !!localStorage.getItem('accessToken');
  },

  isAdmin() {
    const user = this.getCurrentUser();
    return user?.role === 'admin';
  }
};
